/** Why OORI section image (updated to oorilabel.JPEG). */
export const FOUNDER_IMAGE = `${process.env.PUBLIC_URL || ""}/oorilabel.JPEG`;

/** Static catalog image used when founder asset and product pool are unavailable. */
export const EDITORIAL_FALLBACK_IMAGE = "/api/static/products/ethnic/1001586745.jpg";
